import React from 'react';

const Preloader = () => (
  <section className="preloader">
    <div className="circle-3" />
    <div className="circle-2" />
    <div className="circle-1">
      <img
        className="logo"
        src="/images/kcell_white.svg"
        width="95px"
      />
    </div>
  </section>
);

export default Preloader;
